import { Button, Group, Stack, Text } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { Link } from '@tanstack/react-router'

import { useIsAuthenticated, useLogout } from '@repo/common/queries/auth'

export const Route = createFileRoute('/_appish/logout')({
  component: LogoutPage,
})

function LogoutPage() {
  const reset = useLogout()
  const is_auth = useIsAuthenticated()

  return (
    <Group
      gap="xl"
      wrap="nowrap"
      pl={{ base: 'sm', sm: '0' }}
      pr={{ base: 'sm', sm: 'xl' }}
      align="top"
      maw="400"
      mx="auto"
    >
      <Stack miw="300" align="center">
        {!is_auth ? (
          <>
            <Text size="lg">Already logged out</Text>
            <Text size="lg">
              <Link to="/">Login</Link> instead?
            </Text>
          </>
        ) : (
          <Button
            loading={reset.isPending}
            w="100%"
            size="lg"
            mt="lg"
            disabled={!is_auth}
            onClick={() => {
              reset.mutate()
            }}
          >
            Logout?
          </Button>
        )}
      </Stack>
    </Group>
  )
}
